import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useLoading } from "context/LoadingContext";
import { useNotification } from "context/NotificationContext";
import { useAuth } from "context/AuthContext";
import Api from "utils/Api";

const EditarSeries = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const notificar = useNotification();
  const auth = useAuth();
  const api = new Api();
  const { guid: guidParam } = location.state || {};
  const [mensagensResultado, setMensagensResultado] = useState([]);

  const [series, setSeries] = useState({
    nfce: "",
    nfeEntrada: "",
    nfeSaida: "",
    motivo: "",
    lojaId: ""
  });
  const [balcao, setBalcao] = useState({
    cnpj: "",
    codigoLoja: "",
    guid: guidParam
  });
  const [historicos, setHistoricos] = useState([]);

  const carregarDados = () => {
    if (guidParam) {
      setLoading(true);
      api
        .Get({
          endpoint: `/ConfiguracaoSerieNfe/ObterPorBalcaoId?id=${guidParam}`,
          config: auth.GetHeaders()
        })
        .then((resposta) => {
          if (resposta.codigoEstadoHttp === 200) {
            const {
              balcaoCNPJ: cnpj,
              balcaoCodigoLoja: codigoLoja,
              balcaoId: guid,
              nfCe,
              nFeEntrada,
              nFeSaida,
              historico,
              lojaId
            } = resposta.objetoResposta;
            setBalcao({ cnpj, codigoLoja, guid });
            setSeries({
              nfce: nfCe,
              nfeEntrada: nFeEntrada,
              nfeSaida: nFeSaida,
              lojaId
            });
            setHistoricos(historico);
          } else {
            notificar({
              type: "error",
              message: "Erro ao buscar dados da empresa."
            });
          }
        })
        .catch((error) => {
          console.error("Erro ao buscar dados:", error);
          notificar({
            type: "error",
            message: "Erro ao buscar dados da empresa."
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    carregarDados();
  }, [guidParam]);

  const handleSaveSeries = async () => {
    if (!series?.motivo || series.motivo.trim().length < 13) {
      notificar({
        type: "error",
        message: "O motivo deve ter no mínimo 13 caracteres."
      });
      return;
    }

    try {
      setLoading(true);

      const comando = {
        SerieNfceSaida: parseInt(series.nfce, 10),
        SerieNfeEntrada: parseInt(series.nfeEntrada, 10),
        SerieNfeSaida: parseInt(series.nfeSaida, 10),
        Motivo: series.motivo ?? "",
        Cnpj: balcao.cnpj,
        BalcaoId: balcao.guid,
        LojaId: series.lojaId,
        CodigoLoja: balcao.codigoLoja
      };

      const resposta = await api.Post({
        endpoint: "/ConfiguracaoSerieNfe/CriarEditarSerie",
        data: comando,
        config: auth.GetHeaders()
      });
      if (resposta.codigoEstadoHttp === 200) {
        notificar({
          type: "success",
          message: "Séries atualizadas com sucesso!"
        });

        setMensagensResultado(resposta.objetoResposta);
        carregarDados();
      } else {
        notificar({ type: "error", message: "Erro ao atualizar séries." });
      }
    } catch (error) {
      console.error("Erro ao atualizar séries:", error);
      notificar({ type: "error", message: "Erro ao atualizar séries." });
    } finally {
      setLoading(false);
    }
  };

  const dateBodyTemplate = (rowData) => {
    if (rowData.dataAlteracao) {
      const date = new Date(rowData.dataAlteracao);
      const day = `0${date.getDate()}`.slice(-2);
      const month = `0${date.getMonth() + 1}`.slice(-2);
      const year = date.getFullYear();
      const hours = `0${date.getHours()}`.slice(-2);
      const minutes = `0${date.getMinutes()}`.slice(-2);

      return `${day}/${month}/${year} ${hours}:${minutes}`;
    }
    return "";
  };

  return (
    <div className="card p-3">
      <h3>Editar Séries Notas Fiscais</h3>
      <p>
        <strong>CNPJ:</strong> {balcao.cnpj}
        <br />
        <strong>Loja:</strong> {balcao.codigoLoja}
        <br />
        <strong>GUID:</strong> {balcao.guid}
      </p>
      {mensagensResultado.length > 0 && (
        <>
          <div
            style={{
              marginTop: "1rem",
              padding: "1rem",
              border: "1px solid #faebcc",
              backgroundColor: "#fcf8e3",
              borderRadius: "4px",
              color: "#8a6d3b"
            }}
          >
            <h4 style={{ marginTop: 0 }}>Resultado da Operação:</h4>
            <ul style={{ margin: 0, paddingLeft: "1.2rem" }}>
              {mensagensResultado.map((msg) => (
                <li>{msg}</li>
              ))}
            </ul>
          </div>
          <br />
        </>
      )}

      <div className="p-fluid">
        <div style={{ display: "flex", gap: "1rem" }}>
          <div className="p-field" style={{ flex: 1 }}>
            <label htmlFor="nfce">NFCe</label>
            <InputText
              id="nfce"
              value={series.nfce}
              onChange={(e) => setSeries({ ...series, nfce: e.target.value })}
            />
          </div>
          <div className="p-field" style={{ flex: 1 }}>
            <label htmlFor="nfeEntrada">NFe Entrada</label>
            <InputText
              id="nfeEntrada"
              value={series.nfeEntrada}
              onChange={(e) =>
                setSeries({ ...series, nfeEntrada: e.target.value })
              }
            />
          </div>
          <div className="p-field" style={{ flex: 1 }}>
            <label htmlFor="nfeSaida">NFe Saída</label>
            <InputText
              id="nfeSaida"
              value={series.nfeSaida}
              onChange={(e) =>
                setSeries({ ...series, nfeSaida: e.target.value })
              }
            />
          </div>
        </div>

        <div className="p-field" style={{ marginTop: "1rem" }}>
          <label htmlFor="motivo">Motivo</label>
          <InputText
            id="motivo"
            value={series.motivo}
            onChange={(e) => setSeries({ ...series, motivo: e.target.value })}
          />
        </div>
        <br />
        <div className="p-field">
          <Button label="Salvar" onClick={handleSaveSeries} />
        </div>
      </div>
      <hr />
      <h4>Histórico de Alterações</h4>
      {historicos && historicos.length > 0 ? (
        <DataTable value={historicos}>
          <Column header="Data" body={dateBodyTemplate} />
          <Column field="usuarioResponsavelAlteracao" header="Usuário" />
          <Column field="nfeModeloDocumentoFiscal" header="Modelo" />
          <Column field="nfeTipoOperacao" header="Operação" />
          <Column field="motivoAnterior" header="Motivo Anterior" />
          <Column field="serieAntetior" header="Série Anterior" />
          <Column field="motivoAtual" header="Motivo Atual" />
          <Column field="serieAtual" header="Série Atual" />
        </DataTable>
      ) : (
        <p>Sem histórico de alterações.</p>
      )}
    </div>
  );
};

export default EditarSeries;
